import { COGNITO_OSR_LABEL, COGNITO_WORKER_LABEL, FCA_USER_COMPANY_ID } from 'constants/common';

const getUserInfoFromSession = (session: any = {}) => {
  return {
    fullName: session['custom:fullname'],
    email: session.email,
    mobilePhoneNumber: session.phone_number,
    companyUserId: session['custom:companyuserid'],
    companyWorkerId: session['custom:companyworkerid'],
    currentCompanyId: session['custom:currentcompanyid'],
    isFcaUser: session['custom:currentcompanyid'] === FCA_USER_COMPANY_ID,
    isAdmin:
      session['custom:isadmin'] === 'True' ||
      session['custom:isadmininanyproject'] === 'True' ||
      (session['custom:labels']?.includes(COGNITO_OSR_LABEL) &&
        session['custom:currentcompanyid'] === FCA_USER_COMPANY_ID), // OSR users should have admin access
    isSuperAdmin: session['custom:issuperadmin'] === 'True',
    isAdminOnAnyProject: session['custom:isadmininanyproject'] === 'True',
    isWorker: session['custom:labels']?.includes(COGNITO_WORKER_LABEL) && !!session['custom:workerid'],
    isOsr:
      session['custom:labels']?.includes(COGNITO_OSR_LABEL) &&
      session['custom:currentcompanyid'] === FCA_USER_COMPANY_ID,
    workerId: session['custom:workerid'] || '',
    userId: session['cognito:username'] || '',
    permissions: [],
  };
};

export { getUserInfoFromSession };
